import { PureComponent } from 'react';
import ImageWithFallback from './img_with_fallback';

import defaultClasses from './default_tile.less';
import tiktokClasses from './tiktok_tile.less';
import classNames from 'classnames';
import JumpLinkIcon from '../icons/jump_link_icon';
import Clamp from './clamp';
import CarouselIcon from '../icons/carousel_icon';
import VideoIcon from '../icons/video_icon';
import { MediaType } from '../services/type';

type Props = {
  postId: string;
  mediaType: MediaType;
  imageUrl: string;
  smartlink: string;
  displayText: string;
  showDisplayText: boolean;
  onClick: (postId: string) => Promise<any>;
};

export default class Tile extends PureComponent<Props> {
  renderIcon() {
    switch (this.props.mediaType) {
      case MediaType.Album:
        return <CarouselIcon className={defaultClasses.icon} />;
      case MediaType.Video:
        return <VideoIcon className={defaultClasses.icon} />;
      default:
        return null;
    }
  }

  classesByNetwork() {
    return window.TA.networkName === 'tiktok' ? tiktokClasses : defaultClasses;
  }

  render() {
    const {
      postId,
      smartlink,
      imageUrl,
      onClick,
      showDisplayText,
      displayText,
    } = this.props;

    const classes = this.classesByNetwork();

    return (
      <div
        className={classNames(
          classes.tile,
          showDisplayText && classes.showDisplayText,
        )}
      >
        {smartlink ? (
          <a
            href={smartlink}
            target="_blank"
            rel="noreferrer noopener"
            onClick={() => onClick(postId)}
            className={classes.imageWrapper}
          >
            {this.renderIcon()}
            <ImageWithFallback src={imageUrl} className={classes.image} />
            <div className={classes.imageCover}>
              <JumpLinkIcon />
              <div className={classes.visitLabel}>Visit</div>
            </div>
            {showDisplayText ? (
              <Clamp className={classes.displayText} text={displayText} />
            ) : null}
          </a>
        ) : (
          <ImageWithFallback
            src={imageUrl}
            className={classNames(classes.image, classes.imageWrapper)}
          />
        )}
      </div>
    );
  }
}
